import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withRouter } from 'react-router';

const queryString = require('query-string');

class ErrorDialogue extends Component {
    state = { open: true }

    setOpen(value) {
        this.setState({ open: value });
    }

    handleClickOpen = () => {
        this.setOpen(true);
    };

    handleClose = () => {
        this.setOpen(false);
        this.props.history.replace('/home')
    };

    componentDidMount() {
        // axios.get(axios.get('http://10.3.0.44:8088/error')
    }

    render() {
        const { location } = this.props;
        const { open } = this.state;
        const parsed = queryString.parse(location.search);
        console.log(parsed);
        let parsedDescripionText = parsed.description;

        parsedDescripionText = parsedDescripionText ? parsedDescripionText : "Будь-ласка, введіть коректні дані";

        return (
            <Dialog
                open={open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown={true}
            >
                <DialogTitle id="alert-dialog-title">{"Введено некоректні дані"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {parsedDescripionText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary" autoFocus>
                        Так
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withRouter(ErrorDialogue);